export const TabContent = ({ value, tabValue, children }) => {
  return value === tabValue && children;
};
